import InvoiceHelper from '@/helpers/invoiceHelper';

export const AdminAuequitexMixins = {
  methods: {
    isRecourse(invoice) {
      return InvoiceHelper.isRecourse(invoice);
    },
    isReverse(invoice) {
      return InvoiceHelper.isReverse(invoice);
    },
    isNonRecourse(invoice) {
      return InvoiceHelper.isNonRecourse(invoice);
    },
    getFactoringType(invoice) {
      return InvoiceHelper.getFactoringType(invoice);
    },
    adminType(types = []) {
      const user = this.$store.state.auth.user;
      const userRole = user.user_role;

      return types.includes(userRole)
    }
  },
}